var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-group"},[_c('h2',{staticClass:"menu-group-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('ul',_vm._l((_vm.menuItems),function(item){return _c('li',{key:item.name,staticClass:"item-container"},[_c('MenuItem',{attrs:{"item":item,"showActions":false,"isTakeaway":false}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }